import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormHeading } from "../../shared/components/Typograhy";
import { ButtonArea, BackButton } from "../../shared/components/Buttons";
import { Breadcrumb } from "./form/Breadcrumb";
import ServiceItem from "../../shared/components/ServiceItem";
import SlideInAnimation from "../../../ui/shared/components/SlideInAnimation";

const AddServiceForm = ({ serviceList, onBack, onSelectService }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
    }, []);

    return (
        <>
            <SlideInAnimation show={show} appear={true}>
                <Breadcrumb />

                <FormHeading
                    title={t("booking.reservation_question")}
                    subtitle={
                        <>
                            {t("booking.reservation_information_1")}
                            <br />
                            {t("booking.reservation_information_2")}
                        </>
                    }
                />

                <div className="mt-12 flex flex-wrap justify-center gap-8">
                    {serviceList.map((service) => (
                        <ServiceItem
                            key={service.id}
                            service={service}
                            handleClick={(e) => {
                                e.preventDefault();
                                onSelectService(service.type);
                            }}
                        />
                    ))}
                </div>

                <ButtonArea>
                    <BackButton onClick={onBack}>{t("booking.back")}</BackButton>
                </ButtonArea>
            </SlideInAnimation>
        </>
    );
};

export default AddServiceForm;
